/**
 * ARCHITECTURE §5.16 (the decide phase on workers), step 2: a unit's brain as anything other than the brain reads it — its
 * public face (`ActionBrainFace`), from the start-of-tick state. Today the face is the stored brain itself, typed down to
 * the fields others may read (no copy, nothing new in the state, so the per-tick checksum is unchanged); when the brains
 * live on their workers (step 4), the state keeps the faces and this reads them. Pure.
 */
import type { ActionBrainFace, GameState } from '../types';

/** The public face of `unitId`'s brain, as the start-of-tick state holds it (undefined before it first decides). */
export function brainFace(state: Pick<GameState, 'actionBrains'>, unitId: number): ActionBrainFace | undefined {
  return state.actionBrains?.[unitId];
}
